<template>
	<div class="switch">
		<p v-if="label">{{ label }}</p>
		<div :data-item-active="currentActiveItem" class="switch-container">
			<div class="switch-slider"></div>
			<div class="switch-options row centered">
				<div class="col-4 centered option-0" v-html="getIcon(iconLeft)" @click="clickListener(0)"></div>
				<div class="col-4 centered option-1" v-html="getIcon(iconCenter)" @click="clickListener(1)"></div>
				<div class="col-4 centered option-2" v-html="getIcon(iconRight)" @click="clickListener(2)"></div>
			</div>
		</div>
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return {
			getIcon: svgStore.get,
		}
	},
	name: "AppSwitchTriple",
	emits: ["switched"],
	data() {
		return {
			currentActiveItem: this.activeItem,
		}
	},
	props: {
		label: {type: String, default: null},
		activeItem: {type: Number, default: 0, validator(value) {
			return value >= 0 && value <= 2;
		}},
		iconLeft: {type: String, required: true},
		iconCenter: {type: String, required: true},
		iconRight: {type: String, required: true},
	},
	methods: {
		clickListener(index) {
			this.currentActiveItem = index;
			this.$emit('switched', index);
		}
	},
	watch: {
		activeItem(value) {
			if(value !== this.currentActiveItem) {
				this.currentActiveItem = value;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.switch {
	@include centered;
	@include columnFlex;

	p {
		margin-bottom: 5px;
		text-align: left;
		color: $txt_1;
		font-size: 10px;
		line-height: 15px;
		padding: 0 10px;
		width: 100%;
		margin-right: auto;
	}
}

.switch-container {
	position: relative;
	display: inline-block;
	width: 144px;
	height: 35px;
	cursor: pointer;

	& * {
		@include noSelect;
	}

	.row {
		height: 100%;
		position: absolute;
		top: 0;

		.col-4 {
			height: 100%;

			&:deep(svg) {
				height: calc(100% - 20px);

				path.fill {
					fill: var(--color-bg-primary-4);
				}

				path.stroke {
					stroke: var(--color-bg-primary-4);
				}
			}

			&:deep(svg path), &:deep(svg circle), &:deep(svg rect) {
				transition: fill .3s $transition, stroke .3s $transition;
			}
		}
	}

	.switch-slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--color-bg);
		-webkit-transition: .4s;
		transition: .4s;
		box-shadow: 0 1px 2px var(--color-box-shadow-3);
		border-radius: 13px;

		&:before {
			position: absolute;
			content: "";
			height: 29px;
			width: 42px;
			left: 4px;
			top: 50%;
			transform: translateY(-50%);
			background-image: linear-gradient(to right, var(--color-primary), var(--color-secondary));
			-webkit-transition: left .3s $transition;
			transition: left .3s $transition;
			border-radius: 11px;
			box-shadow: inset 0 2px 3px var(--color-box-shadow-dark-2);
		}
	}

	&[data-item-active="0"] {
		.row .col-4:nth-of-type(1):deep(svg) {
			path.fill {
				fill: var(--color-bg);
			}

			path.stroke {
				stroke: var(--color-bg);
			}
		}
	}

	&[data-item-active="1"] {
		.switch-slider:before {
			left: 51px;
		}

		.row .col-4:nth-of-type(2):deep(svg) {
			path.fill {
				fill: var(--color-bg);
			}

			path.stroke {
				stroke: var(--color-bg);
			}
		}
	}

	&[data-item-active="2"] {
		.switch-slider:before {
			left: 98px;
		}

		.row .col-4:nth-of-type(3):deep(svg) {
			path.fill {
				fill: var(--color-bg);
			}

			path.stroke {
				stroke: var(--color-bg);
			}
		}
	}

}

</style>